// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"41edf83c","239":"e39fb35b","455":"2281e389","821":"83f15576","977":"5a4c08f0"}[chunkId] + ".chunk.js";
};